import { ReactElement } from 'react'
import illustration from '../images/Tonno2.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Lähden seuraamaan naisten pitkää taivallusta Helsinkiin ja Tönnön seikkailu loppuu tähän',
    gotoStage: 0
  },
  {
    text: 'Vetäydyn takaisin tyhjentyneeseen tupaan itsekseni',
    gotoStage: 0
  },
  {
    text: 'Kuulin huhua maailmanympärysmatkasta Tönnön kylässä, tätä täytyy tutkia tarkemmin',
    gotoStage: 3
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const TonnoStage2 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle small>Nauhakaupungin tarina</StageTitle>
      <StageText>
        Istut keinutuolissa pienessä tuvassa. Sinua vastapäätä istuva mies on syventynyt lukemaan lehteä, jota hän pitelee väärinpäin kädessään. ”Mitä siellä lehdessä sanotaan?” kuuluu kysymys keittiöstä. ”Kauheit on tapauksia; myrskyjä näkyy ja laivoja on kaatunnu!” mies vastaa. Kansallispuvun kaunista nauhaa kutova nainen naurahtaa. ”Elähän hulluja höpäjä Jussi. Voisitkohan käydä sanomassa naapureille, että kohta lähdetään myyntireissulle?” Katsot ulos ikkunasta ja näet kylän miehiä talkootöissä pellolla.
      </StageText>
      <StageText>
        Ilta alkaa jo hämärtyä, kun astut ovesta ulos ja hieraiset silmiäsi: siellä ne naiset nyt kävelevät kohti Helsinkiä paljain jaloin, kengät olalle heitettynä. Miehet ovat juuri palaamassa pelloilta, yksi kantaa väsynyttä lasta reppuselässään ja osoittaa mäkeä. ”Tiedätkö miksi tätä kutsutaan Nauhakaupungiksi?” hän kysyy lapselta. ”Näetkö, miten nuo tuvat muodostavat valonauhan, joka kulkee tien vartta pitkin mäeltä alas asti? Ja kuinka paljon meillä on taitavia naisia kutomassa äärettömän kauniita nauhoja myytäväksi Helsingissä asti?”. Kudontaa harjoitetaan miltei joka talossa, joten kaunis nimitys on ansaittu.
      </StageText>
      <StageText>
        <strong>Mitä teet seuraavaksi?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default TonnoStage2
